<template>
  <v-dialog v-model.sync="localDialog">
    <template v-slot:activator="{on, attrs}">
      <v-btn v-bind="attrs"
             v-on="on">
        Media Library
      </v-btn>
    </template>

    <v-card flat
            tile>
      <v-card-title>
        Media Library
      </v-card-title>
      <div class="pa-4">
        <div class="d-flex flex-wrap">
          <v-card v-for="image in images"
                  :key="image.id"
                  @click.prevent="selectImage(image)"
                  class="mr-2 mb-2 flex-grow-1 d-flex flex-column"
                  style="width: 230px;">
            <div class="grey lighten-1 fill-height d-flex align-center">
              <div class="d-flex flex-column fill-height flex-grow-1 justify-center align-center">
                <v-img :src="image.location"
                       max-width="230"
                       contain
                       alt="Thumbnail">
                </v-img>
              </div>
            </div>
            <v-divider></v-divider>
            <v-card-text class="font-weight-regular py-2 pb-0 px-2 text-caption">
              {{ image.filename }}
            </v-card-text>
            <v-card-text class="flex flex-grow-1 px-2">

            </v-card-text>
          </v-card>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import {mapGetters} from 'vuex';
import teamAssetService from "../../../../../ml/services/teamAssetService";

export default {
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localDialog: this.dialog,
      images: [],
    }
  },
  computed: {
    ...mapGetters([
      'team',
      'user',
    ]),
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.images = await teamAssetService.getAllImages().catch(() => {});
    },
    selectImage(image) {
      this.$emit('image-selected', image);
    }
  }
}
</script>
